var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.788,
    height: 23.788,
    viewBox: "0 0 23.788 23.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".acal{fill:none;stroke:#fff;stroke-width: 1.2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "acal",
    d: "M380.261,245.08c.293,3.112,3.615,2.621,3.615,2.621,2.029.3,1.726,4.738,1.726,4.738s-.216,4.446-2.266,4.505c0,0-3.243-.876-3.895,2.181s1.19,4.622,4.2,4.415c0,0,4.163-.4,4.783-11.033.343-10.773-3.477-11.323-3.477-11.323C381.982,240.629,379.97,241.968,380.261,245.08Z",
    transform: "translate(461.742 -81.137) rotate(135)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.442bc17aa3f16db5bdc18f1b4879b412.svg";
export { ForwardRef as ReactComponent };